export default __webpack_public_path__ + "static/media/francine3.33ab476f.jpg";